import callApi from "../../services/api";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const DoctorOnboarding = () => {
  const navigate = useNavigate();
  const obj = {
    id: "",
    name: "",
    ifscCode: "",
    occupation: "Doctor",
    mobileNumber: "",
    accountNumber: "",
    qualification: "DOCTORATE",
    accountHolderName: "",
    certificateOrDocument: "",
    specializationMasterId: "",
    officeOrOccupationAddress: "DOCTOR-CLINIC",
  };
  const [formData, setFormData] = useState(obj);

  const [validationError, setValidationError] = useState({
    name: "",
    ifscCode: "",
    occupation: "",
    accountNumber: "",
    qualification: "",
    accountHolderName: "",
    certificateOrDocument: "",
    specializationMasterId: "",
    officeOrOccupationAddress: "",
  });

  const location = useLocation();
  const [specializations, setSpecializations] = useState([]);

  const fetchSpecializationsAPICall = async () => {
    var response = await callApi(
      "/doctors/specializations",
      "GET",
      null,
      false,
      true,
      null
    );
    if (response.status == 200) {
      setSpecializations(response.body);
    }
  };
  var doctorId = location?.state?.doctorId;
  const fetchDoctorProfile = async () => {
    var response = await callApi(
      doctorId ? `/doctors/profile/${doctorId}` : `/doctors/profile`,
      "GET",
      null,
      false,
      true,
      null
    );
    if (response.status == 200) {
      const updatedData = Object.fromEntries(
        Object.entries(response.body).filter(([_, value]) => value != null)
      );      

      setFormData((prevFormData) => ({
        ...prevFormData, 
        ...updatedData 
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.name) {
      errors.name = "Please enter your name";
    }
    if (!formData.specializationMasterId) {
      errors.specializationMasterId = "Please select specialization";
    }
    if (!formData.accountHolderName) {
      errors.accountHolderName = "Please enter account Holder Name";
    }
    if (!formData.accountNumber) {
      errors.accountNumber = "Please enter account number";
    }
    if (!formData.ifscCode) {
      errors.ifscCode = "Please enter IFSC code";
    }
    if (!formData.occupation) {
      errors.occupation = "Please select occupation";
    }
    if (!formData.gender) {
      errors.gender = "Please select your gender";
    }
    if (!formData.email) {
      errors.email = "Please enter email";
    }

    setValidationError(errors);

    return Object.keys(errors).length === 0;
  };

  const handleFormSubmission = async () => {
    if (validateForm()) {
      var response = await callApi(
        doctorId ? `/doctors/profile/${doctorId}` : `/doctors/profile`,
        "POST",
        formData,
        true,
        true,
        null
      );
      if (response?.status == 200) {
        setFormData(obj)
        alert("savedSuccess");
        navigate("/marketing")
      }
    }
  };

  useEffect(() => {
    fetchDoctorProfile();
    fetchSpecializationsAPICall();
  }, []);

  return (
    <>
      <div className="w-[90%] md:w-[70%] m-auto py-[2rem]">
        <form className="w-[100%]" noValidate>
          <h1 className="text-2xl">Personal Details</h1>
          <div className="row">
            <div className="col-md-6 mt-3">
              <label for="text-input" className="form-label">
                Full Name
              </label>
              <input
                type="text"
                className={`form-control ${validationError.name ? 'invalid' : ''}`}       
                id="validationText01"
                placeholder="Full name"
                value={formData?.name || ""}
                onChange={(e) => {
                  const { value } = e.target;
                  if (value && /^[a-zA-Z\s]*$/.test(value)) {
                    setFormData((prevFormData) => ({
                      ...prevFormData,
                      name: value,
                    }));
                    validationError.name =""
                  }
                }}
                required
              />{" "}
              {validationError?.name && (
                <div className="text-danger mb-3">{validationError?.name}</div>
              )}
            </div>
            <div className="col-md-6 mt-3">
              <label for="select-input" className="form-label">
                Gender
              </label>
              <select
                className={`form-select ${validationError.gender ? 'invalid' : ''}`}
                id="select-input"
                aria-label="Default select example"
                onChange={(e) => {
                  const { value } = e.target;
                  // if (value ) {
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    gender: value,
                  }));
                   validationError.gender =""
                  // }
                }}
              >
                <option selected disabled>
                  Select
                </option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
              {validationError?.gender && (
                <div className="text-danger mb-3">
                  {validationError?.gender}
                </div>
              )}
            </div>
            <div className="col-md-6 mt-3">
              <label for="text-input" className="form-label">
                Mobile Number
              </label>
              <input
                type="text"
                className="form-control"
                id="validationText01"
                placeholder="Mobile Number"
                value={formData?.mobileNumber}
                required
                readOnly
                disabled
              />
            </div>
            <div className="col-md-6 mt-3">
              <label for="text-input" className="form-label">
                Email
              </label>
              <input
                type="email"
                className={`form-control ${validationError.email ? 'invalid' : ''}`}
                id="validationText01"
                placeholder="example@example.com"
                value={formData?.email}
                onChange={(e) => {
                  const { value } = e.target;

                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    email: value,
                  }));
                   validationError.email =""
                }}
                required
              />
              {validationError?.email && (
                <div className="text-danger mb-3">{validationError?.email}</div>
              )}
            </div>
            <div className="col-md-6 mt-3">
              <label for="text-input" className="form-label">
                Occupation
              </label>
              <input
                type="text"
                className="form-control"
                id="validationText01"
                value={formData?.occupation}
                placeholder="Your Occupation"
                required
                readOnly
                disabled
              />
            </div>

            <div className="col-md-6 mt-3">
              <label for="select-input" className="form-label">
                Specialization
              </label>
              <select
                className={`form-select ${validationError.specializationMasterId ? 'invalid' : ''}`}
                id="select-input"
                aria-label="Default select example"
                value={formData?.specializationMasterId}
                onChange={(e) => {
                  var value = e.target.value;
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    specializationMasterId: value,
                  }));
                   validationError.specializationMasterId =""
                }}
              >
                <option selected disabled value="">
                  Select
                </option>
                {specializations.map((specialization, index) => (
                  <option key={index} value={specialization.id}>
                    {specialization.name}
                  </option>
                ))}
              </select>
              {validationError?.specializationMasterId && (
                <div className="text-danger mb-3">
                  {validationError?.specializationMasterId}
                </div>
              )}
            </div>
          </div>
          <hr className="mt-3" style={{ color: "lightgray" }} />

          <h1 className="text-2xl mt-3">Bank Details</h1>

          <div className="row">
            <div className="col-md-6 mt-3">
              <label for="text-input" className="form-label">
                Account Holder Name
              </label>
              <input
                type="text"
                className={`form-control ${validationError.accountHolderName ? 'invalid' : ''}`}
                id="validationText01"
                value={formData?.accountHolderName}
                placeholder="Account Holder Name"
                onChange={(e) => {
                  const { value } = e.target;

                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    accountHolderName: value,
                  }));
                   validationError.accountHolderName =""
                }}
                required
              />
              {validationError?.accountHolderName && (
                <div className="text-danger mb-3">
                  {validationError?.accountHolderName}
                </div>
              )}
            </div>
            <div className="col-md-6"></div>
            <div className="col-md-6 mt-3">
              <label for="text-input" className="form-label">
                Account Number
              </label>
              <input
                type="text"
                className={`form-control ${validationError.accountNumber ? 'invalid' : ''}`}
                id="validationText01"
                placeholder="Account Number"
                value={formData?.accountNumber}
                onChange={(e) => {
                  const { value } = e.target;
                  // if (value ) {
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    accountNumber: value,
                  }));
                   validationError.accountNumber =""
                  // }
                }}
                required
              />
              {validationError?.accountNumber && (
                <div className="text-danger mb-3">
                  {validationError?.accountNumber}
                </div>
              )}
            </div>
            <div className="col-md-6 mt-3">
              <label for="text-input" className="form-label">
                IFSC Code
              </label>
              <input
                type="text"
                className={`form-control ${validationError.ifscCode ? 'invalid' : ''}`}
                id="validationText01"
                placeholder=" IFSC Code"
                value={formData?.ifscCode}
                onChange={(e) => {
                  const { value } = e.target;
                  // if (value ) {
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    ifscCode: value,
                  }));
                  validationError.ifscCode=""
                  // }
                }}
                required
              />
              {validationError?.ifscCode && (
                <div className="text-danger mb-3">
                  {validationError?.ifscCode}
                </div>
              )}
            </div>
          </div>

          <button
            type="button"
            className="btn btn-info mt-[2rem]"
            onClick={handleFormSubmission}
          >
            Submit Details
          </button>
        </form>
      </div>
    </>
  );
};
export default DoctorOnboarding;
